export default __webpack_public_path__ + "static/media/hearing.0d02039e.svg";